export default {
  fields: {
    package_id: {
      readOnly: true,
    },
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    }
  },
  relationships: {
    package: 'booking_packages',
    items: 'booking_package_items',
  },
}
